module.exports = __webpack_public_path__ + "img/mrcj-table@2x.87b909b2.png";